import { useSearchParams } from "react-router-dom";

export const useSellModeFilters = () => {
  const [search, setSearch] = useSearchParams();

  const filterByCategory = (id) => {
    if (id === null) search.delete("category_id");
    else search.set("category_id", id);
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterBySearch = (value, isScanBar = false) => {
    if (search.get("is_scan") === "true") return;

    search?.forEach((value, key) => {
      search.delete(key);
    });

    if (value?.length !== 0) {
      search.set("query", value);
      if (isScanBar) search.set("is_scan", isScanBar);
    } else search.delete("query");

    setSearch(search, { replace: true });
  };

  const filterByInventoryType = (value) => {
    if (value === "Services") search.set("type", "services");
    else if (value === "Products") search.set("type", "goods");
    else search.delete("type");
    search.delete("page");
    setSearch(search, { replace: true });
  };

  const filterByPage = (value) => {
    search.set("page", value);
    setSearch(search, { replace: true });
  };

  return {
    search,
    filterByCategory,
    filterBySearch,
    filterByInventoryType,
    filterByPage,
  };
};
